<script setup>
const isOpen = ref(false)

function handleToggle(e) {
  isOpen.value = e.target.open
}
</script>

<template>
  <details class="border-t w-full" @toggle="handleToggle">
    <summary>
      <div
        class="flex flex-row justify-between items-center w-full bg-white p-3 cursor-pointer"
      >
        <div class="flex gap-x-4 w-full">
          <span
            class="w-[22px] h-[22px] grid place-content-center"
            :class="`${isOpen ? 'rotate-180' : 'rotate-0'}`"
          >
            <i
              class="icon-chevron-up text-main-primary font-bold text-[12px]"
            ></i>
          </span>
          <slot name="title" :isOpen="isOpen"></slot>
        </div>
      </div>
    </summary>
    <Transition name="slide-fade">
      <slot v-if="isOpen" name="content"></slot>
    </Transition>
  </details>
</template>

<style lang="scss" scoped>
details > summary {
  list-style: none;
}
details > summary::-webkit-details-marker {
  display: none;
}
</style>
